"use client";

import { ChartData } from "chart.js";

import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { ChipComboChart } from "../../chip-combo-chart/components";
import { extractInsiderHoldingChartData } from "../helpers/extract-insider-holding-chart-data";
import { getInsiderHoldingChartOptions } from "../helpers/insider-hoding-chart-options";
import { InsiderHolding } from "../services/insider-holding";

export const InsiderHoldingChart = ({
  lang,
  data,
}: {
  lang: Lang;
  data: InsiderHolding["historicalHoldings"];
}) => {
  const { t } = getTranslations(lang);
  const chartData = extractInsiderHoldingChartData({ t, data });
  const chartOptions = getInsiderHoldingChartOptions();

  return (
    <div>
      <ChipComboChart
        data={chartData as ChartData<"bar">}
        options={chartOptions}
        aria-label="holding of directors and supervisors chart"
      />
    </div>
  );
};
